/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_OffsetInputs */

const en_templates_offset = /** @type {(inputs: Templates_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset (min)`)
};

const he_templates_offset = /** @type {(inputs: Templates_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היסט (דק׳)`)
};

/**
* | output |
* | --- |
* | "Offset (min)" |
*
* @param {Templates_OffsetInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_offset = /** @type {((inputs?: Templates_OffsetInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_OffsetInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_offset(inputs)
	return he_templates_offset(inputs)
});